import { render, staticRenderFns } from "./OrderSalaries.vue?vue&type=template&id=7e42618f&scoped=true&"
import script from "./OrderSalaries.vue?vue&type=script&lang=js&"
export * from "./OrderSalaries.vue?vue&type=script&lang=js&"
import style0 from "./OrderSalaries.vue?vue&type=style&index=0&id=7e42618f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e42618f",
  null
  
)

export default component.exports